import { render } from "./IssuePage.vue?vue&type=template&id=794dafaa"
import script from "./IssuePage.vue?vue&type=script&lang=js"
export * from "./IssuePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__